import { createTheme } from "@mui/material/styles";

/**
 * Talar panel theme — professional-minimal (docs/06 §1, revised 1405-04):
 * hairline borders instead of shadows, warm paper, quiet grays, emerald as
 * the single accent. Density tuned for operators who live in tables.
 */
export const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: { main: "#0E6B5C", dark: "#0A4F44", light: "#3D8A7C" },
    secondary: { main: "#B8860B" },
    background: { default: "#F7F6F2", paper: "#FFFFFF" },
    divider: "#E8E6DF",
    text: { primary: "#1D1C18", secondary: "#6F6B61" },
    error: { main: "#BA1A1A" },
    success: { main: "#1B7A43" },
    warning: { main: "#9A6700" },
  },
  typography: {
    fontFamily: '"Vazirmatn", "Inter", system-ui, sans-serif',
    fontSize: 13.5,
    h5: { fontWeight: 800, letterSpacing: "-0.3px" },
    h6: { fontWeight: 700 },
    subtitle2: { fontWeight: 700 },
    button: { fontWeight: 600 },
    overline: { fontWeight: 700, letterSpacing: "1px" },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: "none", borderRadius: 8 } },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        outlined: { borderColor: "#E8E6DF" },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { border: "1px solid #E8E6DF", boxShadow: "none" },
      },
    },
    MuiTable: {
      defaultProps: { size: "small" },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head": {
            backgroundColor: "#FAF9F5",
            fontWeight: 700,
            color: "#6F6B61",
            fontSize: 12,
            whiteSpace: "nowrap",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: { "&:last-child td": { borderBottom: 0 } },
      },
    },
    MuiChip: {
      styleOverrides: { root: { fontWeight: 600, borderRadius: 7 } },
    },
    MuiAlert: {
      styleOverrides: { root: { border: "1px solid", borderColor: "transparent" } },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#FCFBF8",
          borderLeft: "1px solid #E8E6DF",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { backgroundColor: "rgba(252, 251, 248, 0.9)", backdropFilter: "blur(8px)" },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: "1px 8px",
          paddingTop: 6,
          paddingBottom: 6,
          "&.active": {
            backgroundColor: "rgba(14, 107, 92, 0.09)",
            color: "#0E6B5C",
            "& .MuiListItemIcon-root": { color: "#0E6B5C" },
            "& .MuiTypography-root": { fontWeight: 700 },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: { root: { minWidth: 36 } },
    },
  },
});
